import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import styles from './PublisherIcon.scss';
import TrafficNumber from './TrafficNumber';

export default class PublisherIcon extends Component {
  static propTypes = {
    publisher: PropTypes.object.isRequired,
    fixedHeight: PropTypes.string
  };

  state = {
    detailsVisible: false,
    tooltipVisible: false,
  }

  toggleDetails = () => {
    this.setState((previousState) => ({
      detailsVisible: !previousState.detailsVisible,
      tooltipVisible: false,
    }));
  }

  toggleTooltip = () => {
    this.setState((previousState) => ({
      tooltipVisible: !previousState.tooltipVisible,
      detailsVisible: false,
    }));
  }

  hideDetails = () => {
    this.setState(() => ({
      tooltipVisible: false,
      detailsVisible: false,
    }));
  }

  publisherName(name) {
    const max_characters = 21

    return (
      name.length > max_characters ? name.substring(0, max_characters - 3) + '...' : name
    )
  }

  render() {
    const { publisher } = this.props;
    const tooltipId = `publisher-tooltip-${this.props.fixedHeight || 'standard'}-${publisher.get('id')}`;
    const style = {};
    const divStyle = {};
    if (publisher.get('logo')) {
      style.backgroundImage = `url(${publisher.get('logo')})`;
      style.backgroundSize = 'contain';
      style.backgroundRepeat = 'no-repeat';
    }

    if (this.props.fixedHeight){
      style.height = this.props.fixedHeight;
      style.width = this.props.fixedHeight;
      divStyle.width = this.props.fixedHeight;
    }

    return (
      <div className={styles.publisher} style={divStyle}>
        <div
          className={styles.publisherIcon}
          id={tooltipId}
          key={tooltipId}
          style={style}
          onClick={this.toggleDetails}
          onMouseOut={this.hideDetails}
        >
          <Tooltip placement="top" target={tooltipId} delay={0} isOpen={this.state.tooltipVisible} toggle={this.toggleTooltip}>
            {publisher.get('name')}
          </Tooltip>
          <Popover placement="top" isOpen={this.state.detailsVisible} target={tooltipId} toggle={this.toggle}>
            <PopoverHeader>{publisher.get('name')}</PopoverHeader>
            <PopoverBody><TrafficNumber traffic={publisher.get('site_unique_users')}/> Monthly Unique Visitors</PopoverBody>
          </Popover>
        </div>
        { !this.props.omitName && <span className="name">
          {this.publisherName(publisher.get('name'))}
        </span>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/PublisherIcon.jsx